"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hsla = exports.hsl = void 0;
var hsl = function (h, s, l) { return [h, s, l]; };
exports.hsl = hsl;
var hsla = function (h, s, l, a) {
    return [h, s, l, a];
};
exports.hsla = hsla;
